import { render } from "./RadioInput.vue?vue&type=template&id=3d0015de&scoped=true&ts=true"
import script from "./RadioInput.vue?vue&type=script&lang=ts"
export * from "./RadioInput.vue?vue&type=script&lang=ts"

import "./radio-input.scss?vue&type=style&index=0&id=3d0015de&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0015de"]])

export default __exports__